/**
 * Component: Footer Component
 * Footer component used to show footer in all page of this app
 */
import React from "react";

import { authConfigs } from "../../../config/aws-config";

import Amplify, { Auth } from "aws-amplify";

import { connect } from "react-redux";

import { NavLink } from "react-router-dom";

import { bindActionCreators } from "redux";

import * as UserActions from "../../user/UserActions";

Amplify.configure({
  Auth: authConfigs.Auth,
});

const oauth = authConfigs.oauth;

Auth.configure({ oauth });

class Footer extends React.Component {
  signOut(e) {
    Auth.signOut()
      .then(() => {
        // this.props.history.push('/');
      })
      .catch((e) => {
        console.log(e);
      });
  }

  /**
   * render() is a react lifecycle method.
   * It uses jsx and returns jsx with backend data.
   */
  render() {
    // console.log('props...', this.props)
    const { cognito_data } = this.props;
    // console.log(user.attributes.email)
    return (
      <footer
        style={{ backgroundColor: this.props.bgColor.toString() }}
        className="text-center d-flex align-items-center"
      >
        <div className="social-icons text-white">
          <NavLink to="/">
            <i className="fa fa-home"></i>
          </NavLink>
        </div>
        <div className="user-name m-auto text-white">
          <span>
            {cognito_data && cognito_data.username ? "Logged in as:" : ""}{" "}
          </span>{" "}
          <strong>
            {cognito_data && cognito_data.username ? cognito_data.username : ""}
          </strong>
        </div>
        <div className="social-icons text-white">
          <a target="_blank" href={"https://sites.google.com/plc.nsw.edu.au/contactus/home"}>
              <img src="assets/img/contact_us_icon.png"/>
          </a>
          {/* <a href="#" onClick={this.signOut.bind(this)}><i className="fa fa-sign-out"></i></a> */}
        </div>
      </footer>
    );
  }
}

/**
 * connect() function connects a react component to a redux store.
 */
export default connect(
  (state) => state.user,
  (dispatch) => bindActionCreators(UserActions, dispatch)
)(Footer);
